var conferenecesList = [
    {
        "year": "2022",
        "yearWork": [
            {
            "data": "Iqra Ali and M. Asif Naeem. Identifying and profiling user interest over time using social data. In 2022 24th International Multitopic Conference (INMIC), pages 1–6. IEEE, 2022.",
            "pdflink": "https://ieeexplore.ieee.org/abstract/document/9972955"
            },
            {
            "data": "Rida Tahir and M. Asif Naeem. A machine learning based approach to identify user interests from social data. In 2022 24th International Multitopic Conference (INMIC), pages 1–6. IEEE, 2022.",
            "pdflink": "https://ieeexplore.ieee.org/abstract/document/9972956"
            },
            {
            "data": "Muhammad Farjad Ali Raza and M. Asif Naeem. Saraiki language word prediction and spell correction framework. In 2022 24th International Multitopic Conference (INMIC), pages 1–6. IEEE, 2022.",
            "pdflink": "https://ieeexplore.ieee.org/abstract/document/9972938"
            },
            {
            "data": "Benjamin Denham, Edmund MK Lai, Roopak Sinha, and M. Asif Naeem. Witan: Unsupervised labelling function generation for assisted data programming. In Proceedings of 48th International Conference on Very Large Databases (VLDB 2022). VLDB Endowment Inc, 2022. (ranked A* in CORE).",
            "pdflink": "https://dl.acm.org/doi/abs/10.14778/3551793.3551797"
            }
    ]
    },
    {
        "year": "2021",
        "yearWork": [
            {
                "data": `Alhanof Almutairi, M. Asif Naeem, Gerald Weber. Understanding Enterprise Systems Adaptability: An Exploratory Survey. In 21th IEEE International Conference on Data Mining
                The Sixth Information Systems International Conference (ISICO 2021).`,
                "pdflink": ``
            },
            {
                "data": `Benjamin Denham, Edmund Lai, Roopak Sinha, and M. Asif Naeem. Gain-some-lose-some: Reliable
                quanti cation under general dataset shift. In 21th IEEE International Conference on Data Mining
                (ICDM 2021). IEEE, 2021, (ranked A* in CORE)`,
                "pdflink": `https://link.springer.com/chapter/10.1007/978-981-13-6052-7_6`
            },
            
        ]
    },
    {
        "year": "2020",
        "yearWork": [
            {
                "data": `Herman Wandabwa, M. Asif Naeem, Farhaan Mirza, Russel Pears, and Andy Nguyen. Multi-interest user proling in short text microblogs. In 15th International Conference on Design Science Research in Information Systems and Technology (DESRIST'20). Springer LNCS, 2020, (ranked A in CORE).`,
                "pdflink": `https://doi.org/10.1007/978-3-030-64823-7_15`
            },
            {
                "data": `Benjamin Denham, Russel Pears, and M. Asif Naeem. Null-labelling: A generic approach for learning in the presence of class noise. In 20th IEEE International Conference on Data Mining (ICDM 2020), (ranked A* in CORE)`,
                "pdflink": `https://doi.org/10.1109/ICDM50108.2020.00114`
            },
            {
                "data": `Herman Wandabwa, M. Asif Naeem, Farhaan Mirza, and Russel Pears. Followback recommendations for sports bettors: A twitter-based approach. In 53rd Hawaii International Conference on System Sciences (HICCS'19). Association for Information Systems IEEE Computer Society Press, 2019, (ranked A in CORE).`,
                "pdflink": `http://hdl.handle.net/10125/64055`
            },
            {
                "data": `Nawal Chanane, Farhaan Mirza, and M. Asif Naeem. mHealth: A qualitative approach towards improving medication adherence. In 30th Australasian Conference on Information Systems (ACIS'19). Association for Information Systems, 2019, (ranked A in CORE).`,
                "pdflink": `https://aisel.aisnet.org/acis2020/29`
            },
        ]
    },
    {
        "year": "2019",
        "yearWork": [
            {
                "data": `Nawal Chanane, Farhaan Mirza, and M. Asif Naeem. Insights of Medication Adherence Management: A Qualitative Study with Healthcare Professionals and
                Technology Designers. In 30th Australasian Conference on Information Systems (ACIS'19). Association for Information Systems, 2019, (ranked A in CORE)`,
                "pdflink": `https://aisel.aisnet.org/acis2019/74/`
            },
            {
                "data": `Christopher J. Rapson, Boon-Chong Seet, M. Asif Naeem, Jeong Eun Lee, and Reinhard Klette. A performance comparison of deep learning methods for real-time localisation of vehicle lights in video frames. In IEEE Intelligent Transportation Systems Conference (ITSC19). IEEE, 2019.`,
                "pdflink": `https://doi.org/10.1109/ITSC.2019.8917087`
            },
            {
                "data": `Adi Darliansyah, Herman Masindano Wandabwa, M. Asif Naeem, Farhaan Mirza, and Russel Pears. Long-term trends in public sentiment in indian demonetisation policy. In Proceedings of Intelligent Technologies and Applications, pages 65–75, Springer, 2019`,
                "pdflink": `https://doi.org/10.1007/978-981-13-6052-7_6`
            },
            {
                "data": `Shraddha Nayak, Md. Akbar Hossain, Farhaan Mirza, M. Asif Naeem, and Noreen Jamil. E-brace:A secure electronic health record access method in medical emergency. In Proceedings of Intelligent Technologies and Applications, pages 16–27, Springer, 2019`,
                "pdflink": `https://doi.org/10.1007/978-981-13-6052-7_2`
            },
            {
                "data": `M. Asif Naeem, Omer Aziz, and Noreen Jamil. Optimising HYBRIDJOIN to process semi-stream data in near-real-time data warehousing. In CONF-IRM 2019 Proceedings. Association for Information Systems, 2019`,
                "pdflink": `https://aisel.aisnet.org/confirm2019/27`
            },
            {
                "data": `Herman Wandabwa, M. Asif Naeem, Farhaan Mirza, and Russel Pears. Topical expressivity in short texts. In CONF-IRM 2019 Proceedings. Association for Information Systems, 2019`,
                "pdflink": `https://aisel.aisnet.org/confirm2019/19`
            },
        ]
    },
    {   "year": "2018",
        "yearWork": [
            {
                "data": `Christopher J Rapson, Boon-Chong Seet, M. Asif Naeem, Jeong Eun Lee, Mahmoud Al-Sarayreh, and Reinhard Klette. Reducing the pain: A novel tool for efficient ground-truth labelling in images. In Proceedings of 33rd IEEE Conference on Image and Vision Computing New Zealand (IVCNZ), (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1109/IVCNZ.2018.8634750`
            },
     ]
    },
    {
        "year": "2017",
        "yearWork": [
            {
                "data": `Akbar Hossain, Farhaan Mirza, M. Asif Naeem, and Jairo Gutierrez, "A crowd sourced framework for neighbour assisted medical emergency system", In 2017 27th International Conference on Telecommunication Networks and Applications (ITNAC), pages 1-6. IEEE, 2017. (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1109/ATNAC.2017.8215436`
            },
            {
                "data": `Hoa Nguyen, Farhaan Mirza, M. Asif Naeem, Mirza Mansoor Baig, "Detecting Falls Using a Wearable Accelerometer Motion Sensor",  Proceedings of 14th EAI International Conference on Mobile and Ubiquitous Systems: Computing, Networking and Services (MOBIQUITOUS 2017). (ranked A in CORE)`,
                "pdflink": `https://doi.org/10.1145/3144457.3144484`
            },
            {
                "data": `M. Asif Naeem, Kim Tung Nguyen, and Gerald Weber, "A multi-way semi-stream join for a nearreal-time data warehouse", Proceedings of 28th Australasian Database Conference. Springer, 2017. (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1007/978-3-319-68155-9_5`
            },
            {
                "data": `Ali Haider Hussein Ghazala, M. Asif Naeem, Farhaan Mirza, Noreen Jamil, “Uncovering Useful Patterns in Shopping Cart Data”, Proceedings of IEEE 21st International Conference on Computer Supported Cooperative Work in Design (CSCWD 2017). (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1109/CSCWD.2017.8066719`
            },
            {
                "data": `Herman Wandabwa, M. Asif Naeem, Farhaan Mirza, “Document Level Semantic Comprehension of Noisy Text Streams via Convolutional Neural Networks”, Proceedings of IEEE 21st International Conference on Computer Supported Cooperative Work in Design (CSCWD 2017). (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1109/CSCWD.2017.8066740`
            },
            {
                "data": `Hoa Hong Nguyen, Farhaan Mirza, M. Asif Naeem, and Minh Nguyen, “A Review on IoT Healthcare Monitoring Applications and a Vision for Transforming Sensor Data into Real-time Clinical Feedback”, Proceedings of IEEE 21st International Conference on Computer Supported Cooperative Work in Design (CSCWD 2017) (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1109/CSCWD.2017.8066704`
            },
            {
                "data": `Herman Wandabwa, M. Asif Naeem, and Farhaan Mirza. Aspect of Blame in Tweets: A Deep Recurrent Neural Network Approach. ACM, WWW 2017, (ranked A* in CORE)`,
                "pdflink": `https://doi.org/10.1145/3041021.3051157`
            },
            {
                "data": `Nawal Chanane, Farhaan Mirza, M. Asif Naeem, M. Asfahaan Mirza, "Acceptance of Technology-Driven Interventions for Improving Medication Adherence", Proceedings of International Conference on Future Network Systems and Security (FNSS), Springer, 2017.`,
                "pdflink": `https://doi.org/10.1007/978-3-319-65548-2_15`
            },
            {
                "data": `Erum Mehmood, M. Asif Naeem, "Optimization of cache-based semi-stream joins", Proceedings of IEEE 2nd International Conference on Cloud Computing and Big Data Analysis (ICCCBDA), IEEE, 2017.`,
                "pdflink": `http://ieeexplore.ieee.org/document/7951887/citations`
            },
        ]
    },
    {
        "year": "2016",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Christof Lutteroth, Gerald Weber, “Optimising Queue-based Semi-Stream Joins by Introducing a Queue of Frequent Pages”, Proceedings of 27th Australian Database Conference (ADC), Springer-Verlag, 2016.  (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1007/978-3-319-46922-5_32`
            },
           
        ]
    },
    {
        "year": "2015",
        "yearWork": [
            {
                "data": `Hao Gao, M. Asif Naeem, Christof Lutteroth, and Gerald Weber. S3J: A Parallel Semi-Stream Similarity Join. Proceedings of 18th International Workshop On Data Warehousing and OLAP (DOLAP), ACM, 2015, (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1145/2811222.2811226`
            },
            {
                "data": `M. Asif Naeem, Imran Sarwar Bajwa, Noreen Jamil, “A Cached-based Approach to Enrich Stream Data with Master Data”, Proceedings of 10th IEEE International Conference on Digital Information Management (ICDIM'15) 2015.`,
                "pdflink": `https://doi.org/10.1007/978-3-319-19548-3_5`
            },
            {
                "data": `M. Asif Naeem, Imran Sarwar Bajwa, and Noreen Jamil. A Cached-based Approach to Enrich Stream Data with Master Data. Proceedings of 10th IEEE International Conference on Digital Information Management (ICDIM'15) 2015`,
                "pdflink": `https://doi.org/10.1109/ICDIM.2015.7381874`
            },
        ]
    },
    {
        "year": "2014",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gerald Weber, Christof Lutteroth, Gillian Dobbie, “Optimizing Queue-based Semi-Stream Joins with Indexed Master Data”, Proceedings of 16th International Conference on Data Warehousing and Knowledge Discovery (DaWaK), Springer-Verlag, 2014. (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1007/978-3-319-10160-6_16`
            },
            {
                "data": `M. Asif Naeem, “A caching approach to process stream data in data warehouse”, Proceedings of 9th IEEE International Conference on Digital Information Management (ICDIM'14), IEEE, 2014.`,
                "pdflink": `https://doi.org/10.1109/ICDIM.2014.6991406`
            },
            {
                "data": `Aqsa Mahmood, Kiran Qazi, Imran Sarwar Bajwa, M. Asif Naeem, “Natural language processing based interpretation of skewed graphs”, Proceedings of 3rd International Conference on Advances in Computing, Communications and Informatics (ICACCI), IEEE, 2014.`,
                "pdflink": `https://doi.org/10.1109/ICACCI.2014.6968323`
            },
            {
                "data": `Shabana Ramzan, Imran Sarwar Bajwa, Ikram Ul Haq, M. Asif Naeem, “A model transformation from NL to SBVR”, Proceedings of 9th IEEE International Conference on Digital Information Management (ICDIM), IEEE, 2014.`,
                "pdflink": `https://doi.org/10.1109/ICDIM.2014.6991430`
            },
        ]
    },
    {
        "year": "2013",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gillian Dobbie, Gerald Weber, Christof Lutteroth, “A Generic Front-Stage for Semi-Stream Processing”. Proceedings of ACM 22nd International Conference on Information and Knowledge Management (CIKM), ACM, 2013. (ranked A in CORE)`,
                "pdflink": `https://doi.org/10.1145/2505515.2505734`
            },
            {
                "data": `M. Asif Naeem, Gillian Dobbie, Gerald Weber, Christof Lutteroth, “SSCJ: A Semi-Stream Cache Join using a Front-Stage Cache Module”. Proceedings of 15th International Conference on Data Warehousing and Knowledge Discovery (DaWaK), Springer-Verlag, 2013. (ranked B in CORE) `,
                "pdflink": `https://doi.org/10.1007/978-3-642-40131-2_20`
            },
            {
                "data": `M. Asif Naeem, “Efficient Processing of Semi-Stream Data”, Proceedings of 8th IEEE International Conference on Digital Information Management (ICDIM), IEEE, 2013.`,
                "pdflink": `https://doi.org/10.1109/ICDIM.2013.6694035`
            },
            {
                "data": `M. Asif Naeem, “Tuned X-HYBRIDJOIN for Near-Real-Time Data Warehousing”. Proceedings of 15th Asia-Pacific Web Conference, APWeb (APWeb), Springer-Verlag, 2013.`,
                "pdflink": `https://doi.org/10.1007/978-3-642-37401-2_49`
            },
            {
                "data": `M. Asif Naeem, "A Robust Join Operator to Process Streaming Data in Real-time Data Warehousing", Proceedings of 8th IEEE International Conference on Digital Information Management (ICDIM), IEEE, 2013, pp. 119-124.`,
                "pdflink": `https://doi.org/10.1109/ICDIM.2013.6693964`
            },
        ]
    },
    {
        "year": "2012",
        "yearWork": [
            {
                "data": `M Asif Naeem, Gillian Dobbie, Gerald Weber, “A Lightweight Stream based Join with Limited Resource Consumption”, Proceedings of 14th International Conference on Data Warehousing and Knowledge Discovery (DaWaK), Springer-Verlag, 2012. (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1007/978-3-642-32584-7_35`
            },
            {
                "data": `M Asif Naeem, Saif Ullah, Imran Sarwar Bajwa, “Interacting with Data Warehouse by Using a Natural Language Interface”, Proceedings of 17th International conference on Applications of Natural Language Processing to Information Systems (NLDB),Springer-Verlag, 2012`,
                "pdflink": `https://doi.org/10.1007/978-3-642-31178-9_50`
            },
            {
                "data": `M Asif Naeem, Gillian Dobbie, Gerald Weber, Imran Sarwar Bajwa, “Resource Optimization for Processing of Stream Data in Data Warehouse Environment”, Proceedings of International Conference on Advances in Computing, Communications and Informatics (ICACCI), ACM, 2012.`,
                "pdflink": `https://doi.org/10.1145/2345396.2345407`
            },
            {
                "data": `M Asif Naeem, Imran Sarwar Bajwa, “Generating OLAP Queries From Natural Language Specification”, Proceedings of International Conference on Advances in Computing, Communications and Informatics (ICACCI), ACM, 2012.`,
                "pdflink": `https://doi.org/10.1145/2345396.2345522`
            },
            {
                "data": `M. Asif Naeem, Gillian Dobbie, Gerald Weber, Imran Sarwar Bajwa, “Efficient Usage of Memory Resources in Near-Real-Time Data Warehousing”, Proceedings of International Multi-Topic conference, Springer-Verlag, 2012.`,
                "pdflink": `https://doi.org/10.1007/978-3-642-28962-0_32`
            },
            {
                "data": `M. Asif Naeem, Gillian Dobbie, Gerald Weber, Imran Sarwar Bajwa, “A Parametric Analysis of Stream based Joins”, Proceedings of International Multi-Topic conference, Springer-Verlag, 2012.`,
                "pdflink": `https://doi.org/10.1007/978-3-642-28962-0_31
                `
            },
            {
                "data": `Kashif Hameed, Imran Bajwa and M. Asif Naeem, “A Novel Approach for Automatic Generation of UML Class Diagrams from XMI”, Proceedings of International Multi-Topic conference, Springer-Verlag, 2012.`,
                "pdflink": `https://doi.org/10.1007/978-3-642-28962-0_17`
            },
            {
                "data": ` Asif Naeem, Gillian Dobbie, Gerald Weber, “Optimised X-HYBRIDJOIN for Near-real-time Data Warehousing”, Proceedings of 23rd Australasian Database Conference (ADC), CRPIT, 2012. (ranked B in CORE)`,
                "pdflink": `http://dl.acm.org/citation.cfm?id=2483744`
            },
        ]
    },
    {
        "year": "2011",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gillian Dobbie, Gerald Weber, “X-HYBRIDJOIN for Near-real-time Data Warehousing”, Proceedings of 28th British National Conference on Databases (BNCOD), Springer-Verlag, 2011. (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1007/978-3-642-24577-0_5`
            },
            {
                "data": `Imran Sarwar Bajwa, M. Asif Naeem, “On Specifying Requirements using a Semantically Controlled Representation”, Proceedings of 16th International Conference on Applications of Natural Languages to Information Systems, Springer-Verlag, 2011.`,
                "pdflink": `https://doi.org/10.1007/978-3-642-22327-3_23`
            },
            {
                "data": `Ashfa Umber, Imran Sarwar Bajwa, M. Asif Naeem, “NL-Based Automated Software Requirements Elicitation and Specification”, Proceedings of First International Conference on Advances in Computing and Communications, 2011.`,
                "pdflink": `https://doi.org/10.1007/978-3-642-22714-1_4`
            },
            {
                "data": `Imran Sarwar Bajwa, M. Asif Naeem, Ahsan Ali Chaudhri, Shahzad Ali, “A Controlled Natural Language Interface to Class Models”, Proceedings of 13th International Conference on Enterprise Information Systems, 2011.`,
                "pdflink": `http://hdl.handle.net/10292/4060`
            },
        ]
    },
    {
        "year": "2010",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gill Dobbie, Gerald Weber, “R-MESHJOIN for Near-Real Time Data Warehousing”, Proceedings of 13th International Workshop On Data Warehousing and OLAP (DOLAP), ACM, 2010. (ranked B in CORE)`,
                "pdflink": `https://doi.org/10.1145/1871940.1871952`
            },
            {
                "data": `Shafiq Alam, Gillian Dobbie, Patricia Riddle and M. Asif Naeem, “Particle Swarm Optimization Based Hierarchical Agglomerative Clustering”, Proceedings of IEEE/WIC/ACM International Conference on Intelligent Agent Technology, 2010. (ranked B in CORE)`,
                "pdflink": `http://ieeexplore.ieee.org/stamp/stamp.jsp?tp=&arnumber=5616434`
            },
            {
                "data": `Shafiq Alam, Gillian Dobbie, Patricia Riddle and M. Asif Naeem, “A Swarm Intelligence Based Clustering Approach for Outlier Detection”, Proceedings of WCCI2010: IEEE World Congress on Computation Intelligence, 2010.`,
                "pdflink": `http://ieeexplore.ieee.org/stamp/stamp.jsp?tp=&arnumber=5586152`
            },
        ]
    },
    {
        "year": "2009",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gill Dobbie, Gerald Weber, “Comparing Global Optimization and Default Settings of Stream-based Joins”, Proceedings of Business Intelligence for the Real Time Enterprise (BIRTE, VLDB Workshop), Springer-Verlag, 2009.`,
                "pdflink": `https://doi.org/10.1007/978-3-642-14559-9_10`
            },
        ]
    },
    {
        "year": "2008",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Gill Dobbie, Gerald Weber, “An Event-Based Near Real-Time Data Integration Architecture”, Proceedings of International workshop on Middleware for Web Services, 2008.`,
                "pdflink": `https://core.ac.uk/download/pdf/56363102.pdf`
            },
        ]
    },
    {
        "year": "2007",
        "yearWork": [
            {
                "data": `M. Asif Naeem, Imran S. Bajwa and M. Abbas Choudhary, “Hidden Web Data Processing for Knowledge Management”, Proceedings of IEEE International Conference on Advanced Computer vision and Information Technology, 2007.`,
                "pdflink": `https://www.academia.edu/728675/Hidden_Web_Data_Processing_for_Knowledge_Management`
            },
        ]
    },
    {
        "year": "2006",
        "yearWork": [
            {
                "data": `Imran Sarwar Bajwa, M. Asif Naeem, Riaz Ul Amin, Dr. Muhammad Nawaz, “Web Information Mining Framework using XML Based Knowledge Representation Engine”, Proceedings of 2nd International Conference on Software Engineering, 2006.`,
                "pdflink": `http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.135.7235&rep=rep1&type=pdf`
            },
            {
                "data": `Imran Sarwar Bajwa, M. Asif Naeem, Riaz Ul Amin, Dr. Abbas Choudhary, “Speech Language Processing Interface for Object Oriented Application Design using a Rule-base Framework”, Proceedings of 4th International Conference on Computer Applications, 2006.`,
                "pdflink": `http://www.cs.bham.ac.uk/~isb855/papers/01%20-%20OOD%20-%20ICCA06.pdf`
            },
        ]
    },
]
export default conferenecesList;